import { render } from "./IndustryRoleFields.vue?vue&type=template&id=f9b94a46&scoped=true"
import script from "./IndustryRoleFields.vue?vue&type=script&lang=js"
export * from "./IndustryRoleFields.vue?vue&type=script&lang=js"

import "./IndustryRoleFields.vue?vue&type=style&index=0&id=f9b94a46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b94a46"]])

export default __exports__